export function Meter({ value, max = 100, showValue = true }: { value: number; max?: number; showValue?: boolean }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="rr-meter" role="meter" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max}>
      <div className="rr-meter__track">
        <div className="rr-meter__fill" style={{ width: `${pct}%` }} />
      </div>
      {showValue && <span className="rr-meter__value">{Math.round(value)}</span>}
    </div>
  );
}

export function Segments({ value, total = 10 }: { value: number; total?: number }) {
  const on = Math.round((value / 100) * total);
  return (
    <div className="rr-segments" aria-hidden="true">
      {Array.from({ length: total }).map((_, i) => (
        <span key={i} className={`rr-segments__seg${i < on ? ' rr-segments__seg--on' : ''}`} />
      ))}
    </div>
  );
}

export function Signal({ tone, children }: { tone: 'up' | 'flat' | 'down' | 'alert'; children: React.ReactNode }) {
  const icon = { up: '↑', flat: '↗', down: '↓', alert: '!' }[tone];
  const cls = { up: 'up', flat: 'flat', down: 'down', alert: 'down' }[tone];
  return (
    <div className="rr-signal">
      <span className={`rr-signal__icon rr-signal__icon--${cls}`}>{icon}</span>
      <span>{children}</span>
    </div>
  );
}
